// 这里的值将在构建过程中使用 cross-env 传递给 DEPLOY_ENV 环境变量
export default {
  DEPLOY_ENV: process.env.DEPLOY_ENV || 'development'
};
